'use client';

import * as ToggleGroup from '@radix-ui/react-toggle-group';
import { List, SquaresFour } from 'phosphor-icons';
import { c } from '../../../utils/tailwind-merge';
import type {
  ViewModeToggleProps,
  ViewModeToggleValue,
} from './ViewModeToggle.types';

export const ViewModeToggle = ({
  value,
  onValueChange,
  microcopy,
  className = '',
}: ViewModeToggleProps) => {
  const handleChange = (newValue: string) => {
    if (newValue) {
      onValueChange(newValue as ViewModeToggleValue);
    }
  };

  const itemBaseClasses =
    'flex h-9 w-9 md:h-12 md:w-12 items-center justify-center transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-blue focus-visible:ring-offset-2';
  const itemInactiveClasses = 'text-grey-600 hover:text-grey-900';
  const itemActiveClasses = 'text-grey-900';

  return (
    <ToggleGroup.Root
      type="single"
      value={value}
      onValueChange={handleChange}
      aria-label={microcopy.ariaLabel}
      className={c('flex items-center gap-2', className)}
    >
      <ToggleGroup.Item
        value="grid"
        aria-label={microcopy.grid}
        className={c(
          itemBaseClasses,
          value === 'grid' ? itemActiveClasses : itemInactiveClasses
        )}
      >
        <List
          className="h-5 w-5 lg:h-6 lg:w-6"
          weight={value === 'grid' ? 'bold' : 'regular'}
        />
      </ToggleGroup.Item>
      <ToggleGroup.Item
        value="collection"
        aria-label={microcopy.collection}
        className={c(
          itemBaseClasses,
          value === 'collection' ? itemActiveClasses : itemInactiveClasses
        )}
      >
        <SquaresFour
          className="h-5 w-5 lg:h-6 lg:w-6"
          weight={value === 'collection' ? 'fill' : 'regular'}
        />
      </ToggleGroup.Item>
    </ToggleGroup.Root>
  );
};

ViewModeToggle.displayName = 'ViewModeToggle';
